// extracted by mini-css-extract-plugin
export var searchHeader = "_92-0";
export var searchHeaderDark = "_92-1";